"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _ = require("../");

var _menu = require("../menu");

var _subMenu = require("../sub-menu");

var _messages = require("../../../constants/messages");

var _routes = require("../../../constants/routes");

var SettingsMenu = function SettingsMenu(_ref) {
  var activeHoverListItem = _ref.activeHoverListItem,
      activeListItem = _ref.activeListItem,
      customLinkRenderer = _ref.customLinkRenderer,
      isLoggedIn = _ref.isLoggedIn,
      onItemMouseEnter = _ref.onItemMouseEnter,
      onItemMouseLeave = _ref.onItemMouseLeave;
  var isActive = _.NAV_MENUS.SETTINGS === activeListItem;

  var loggedInSettingsItems = _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_subMenu.SubNavItem, {
    key: "settings"
  }, _react.default.createElement(_subMenu.SubMenuItem, {
    customLinkRenderer: customLinkRenderer,
    label: _messages.MESSAGE_ID.SETTINGS_SUB_MENU,
    route: _routes.ROUTE.SETTINGS
  })), _react.default.createElement(_subMenu.SubNavItem, {
    key: "help"
  }, _react.default.createElement(_subMenu.SubMenuItem, {
    customLinkRenderer: customLinkRenderer,
    label: _messages.MESSAGE_ID.HELP_SUB_MENU,
    route: _routes.ROUTE.HELP
  })), _react.default.createElement(_subMenu.SubNavItem, {
    key: "signOut"
  }, _react.default.createElement(_subMenu.SubMenuItem, {
    customLinkRenderer: customLinkRenderer,
    label: _messages.MESSAGE_ID.SIGN_OUT_SUB_MENU,
    route: _routes.ROUTE.LOGOUT
  })));

  var loggedOutSettingsItems = _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_subMenu.SubNavItem, {
    key: "signIn"
  }, _react.default.createElement(_subMenu.SubMenuItem, {
    customLinkRenderer: customLinkRenderer,
    label: _messages.MESSAGE_ID.SIGN_IN_SUB_MENU,
    route: _routes.ROUTE.LOGIN
  })), _react.default.createElement(_subMenu.SubNavItem, {
    key: "help"
  }, _react.default.createElement(_subMenu.SubMenuItem, {
    customLinkRenderer: customLinkRenderer,
    label: _messages.MESSAGE_ID.HELP_SUB_MENU,
    route: _routes.ROUTE.HELP
  })));

  return _react.default.createElement(_menu.MenuItem, {
    activeHoverListItem: activeHoverListItem,
    altCountBadge: false,
    as: "div",
    customLinkRenderer: customLinkRenderer,
    hideLabel: true,
    icon: "settings",
    id: _.NAV_MENUS.SETTINGS,
    isSelected: isActive,
    label: _messages.MESSAGE_ID.SETTINGS_SUB_MENU,
    noSelectionUnderline: true,
    onMouseEnter: onItemMouseEnter,
    onMouseLeave: onItemMouseLeave,
    route: _routes.ROUTE.SETTINGS,
    showIndicatorDot: false,
    subMenuUI: _react.default.createElement(_subMenu.SubMenu, {
      align: _subMenu.ALIGNMENT.RIGHT
    }, isLoggedIn ? loggedInSettingsItems : loggedOutSettingsItems)
  });
};

var _default = SettingsMenu;
exports.default = _default;